import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/public/assets/goat-slider-mob.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/goat-slider.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/goat-spins-banner-3-desk.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/goat-spins-banner-3-mob.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/goat-spins-text-banner-2-desk.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/goat-spins-text-banner-2-mob.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/BarFooter.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/CarouselOwlHGames.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/HomeHeader.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeTestimonials.jsx");
